import { useSetAtom } from 'jotai'
import { useMutation } from '@tanstack/react-query'
import { AccountModel, AccountPersistentStore, GlobalThemePersistentStore } from '@/main/store'
import api from '@/infra/api'

export interface ILogin {
  email: string
  password: Storage
}

export const useAuth = (navigate?: any) => {
  const setAccountStore = useSetAtom(AccountPersistentStore)
  const setTheme = useSetAtom(GlobalThemePersistentStore)

  const { mutate, isLoading } = useMutation({
    mutationFn: (payload: ILogin) => api.post<AccountModel>('resale-bff/login', payload),
    onSuccess: (res) => {
      const account = Object.assign(res.data)
      const { theme } = account.resale
      setTheme(JSON.parse(theme))
      setAccountStore(account)
    },
  })

  const logout = (resaleSite: string) => {
    setAccountStore({})
    navigate(resaleSite ? `/${resaleSite}/login` : '/login')
  }

  return {
    login: mutate,
    logout,
    isLoading,
  }
}
